
import { formatDate } from "~/utils";
export default {
  props: ["list"],
  methods: {
    transformDate(date) {
      return formatDate(date);
    },
  },
};
